"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var useOptions = function useOptions(children, _ref) {
  var selectId = _ref.selectId,
      setIsInputFocused = _ref.setIsInputFocused,
      setInputData = _ref.setInputData;
  var selectMenuRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      activeOption = _useState2[0],
      setActiveOption = _useState2[1]; // keep track on which element is currently clicked with onMouseDown event


  var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      clickedElement = _useState4[0],
      setClickedElement = _useState4[1];

  var changeActiveOption = function changeActiveOption(option) {
    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      hide: true
    },
        hide = _ref2.hide;

    setInputData({
      value: option.value,
      id: option.id
    });
    setActiveOption(option);

    if (hide) {
      setIsInputFocused(false);
      setActiveOption(null);
    }
  };

  var options = _react["default"].Children.map(children, function (element) {
    var overrideProps = {
      'id': "suggestion-result-".concat(selectId, "-").concat(element.props.id),
      'value': element.props.value,
      'data-select-id': element.props.id,
      'onMouseDown': function onMouseDown() {
        // Firefox and Safari have relatedTarget null.
        // Therefore we cannot use onClick event
        // since it's not getting fired
        // because onBlur input listener cause rerender.
        setClickedElement(element.props.id);
      },
      'onMouseUp': function onMouseUp(event) {
        if (clickedElement === element.props.id) {
          changeActiveOption({
            value: element.props.value,
            id: element.props.id
          });
        }

        setClickedElement(null);
        event.stopPropagation();
      },
      'selected': element.props.id === (activeOption === null || activeOption === void 0 ? void 0 : activeOption.id)
    };
    return /*#__PURE__*/_react["default"].cloneElement(element, _objectSpread(_objectSpread({}, element.props), overrideProps));
  }) || [];

  var handleInputKeyEvent = function handleInputKeyEvent(event) {
    var pos = options.findIndex(function (s) {
      return s.props['data-select-id'] === (activeOption === null || activeOption === void 0 ? void 0 : activeOption.id);
    }) || options.length;
    var direction = 1;
    var suggestion = {};

    switch (event.key) {
      case 'Esc': // IE/Edge specific value

      case 'Escape':
        setIsInputFocused(false);
        break;

      case 'Enter':
        event.preventDefault();
        event.stopPropagation();
        setIsInputFocused(false);
        break;

      case 'Up': // IE/Edge specific value

      case 'ArrowUp':
      case 'Down': // IE/Edge specific value

      case 'ArrowDown':
        event.preventDefault();
        event.stopPropagation();
        if (options.length === 0) return;

        if (activeOption == null) {
          // eslint-disable-next-line prefer-destructuring
          suggestion = options[0];
          changeActiveOption({
            value: suggestion.props.value,
            id: suggestion.props['data-select-id']
          }, {
            hide: false
          });
        } else {
          direction = ['ArrowDown', 'Down'].includes(event.key) ? 1 : -1;
          pos = (pos + direction) % options.length;
          suggestion = options[pos];
          changeActiveOption({
            value: suggestion.props.value,
            id: suggestion.props['data-select-id']
          }, {
            hide: false
          });
        }

        selectMenuRef.current.querySelector("#suggestion-result-".concat(selectId, "-").concat(suggestion.props['data-select-id'])).scrollIntoView(false);
        break;

      default:
    }
  };

  var handleInputBlurEvent = function handleInputBlurEvent(event) {
    // check if onBlur happen within select
    var el = event.relatedTarget;
    if (clickedElement === null && !(el && el.dataset.selectId === clickedElement)) setIsInputFocused(false);
  };

  return [selectMenuRef, options, activeOption, setClickedElement, handleInputKeyEvent, handleInputBlurEvent];
};

var _default = useOptions;
exports["default"] = _default;